import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./i18n";
import { PushNotificationPrompt } from "./components/PushNotificationPrompt";
import { ServiceWorkerUpdater } from "./components/ServiceWorkerUpdater";
import { AppBuildTokenBridgeProvider } from "./components/AppBuildTokenBridgeProvider";
import { PullToRefreshIndicator } from "./components/PullToRefreshIndicator";
import { supabase } from "./integrations/supabase/client";
import { persistentStorage } from "./lib/persistentAuth";

// Patch supabase auth to use IndexedDB-backed storage for mobile app durability
// This prevents logouts when the OS clears localStorage in WebView wrappers
(supabase as any).auth.storage = persistentStorage;

// Service worker is registered automatically by VitePWA (injectManifest strategy)
// Push notification handlers are defined in public/sw.js

createRoot(document.getElementById("root")!).render(
  <>
    <App />
    <AppBuildTokenBridgeProvider />
    <PushNotificationPrompt />
    <ServiceWorkerUpdater />
    <PullToRefreshIndicator />
  </>
);
